<template>
  <q-list v-if="data?.items.length">
    <q-item
      v-for="item in items"
      :key="item.id"
      :href="item.url ?? item.file?.url"
      target="_blank"
    >
      <q-item-section
        v-if="item.url || item.file"
        avatar
      >
        <q-avatar
          :icon="mdiCalendarSyncOutline"
          size="xl"
          color="secondary"
        />
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-h6 text-weight-medium">
          {{ item.title }}
        </q-item-label>
        <q-item-label class="text-body2">
          Ends {{ relative(item.endDt) }} ({{
            format(item.endDt, 'MMM D, YYYY')
          }})
        </q-item-label>
      </q-item-section>
      <q-item-section avatar>
        <q-avatar
          :icon="mdiLinkVariant"
          size="xl"
          text-color="secondary"
        />
      </q-item-section>
    </q-item>
  </q-list>
</template>

<script lang="ts" setup>
import { mdiCalendarSyncOutline, mdiLinkVariant } from '@quasar/extras/mdi-v7';
import type { PaginatedCollection, RebateResponse } from '~/types/ecommerce';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});

const { $ecommerce } = useNuxtApp();

const { format, relative } = useDateFormat();

const { data } = await useAsyncData(
  `products_${props.id}_rebates`,
  () => $ecommerce.fetch<PaginatedCollection<RebateResponse>>('rebates', {
    params: {
      filters: `ProductId==${props.id}`,
    },
  }),
  {
    getCachedData: getCachedPayload,
  },
);

const items = computed(() => data.value?.items ?? []);
</script>
